import { AxiosError } from "axios"

export const checkResponseStatus = (error:AxiosError) =>{
    if (error.name === 'CanceledError') {
        return false
    }
    console.error(error?.response?.status)
    if(error?.response?.status===401) {
        window.location.href = "/login"
        return true
    }
    if(error?.response?.status===403) {
        window.location.href = "/accessdenied"
        return true
    }
    if([502, 503].includes(error?.response?.status!)) {
        window.location.href = `/maintenance?from=${encodeURI(window.location.pathname + window.location.search)}`
        return true
    }
    return false
}